import React, { FC, useContext } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Link, LinkProps } from '@fiverr-private/typography';
import { seeMoreEventPayload } from '../../utils';
import { EventsReportApiContext, mixpanelEventEnrichment } from '../../utils/events';
import { MIXPANEL_EVENT_TITLE } from '../../utils/constants';

interface SeeMoreLinkProps extends LinkProps {
  text?: string | number;
  link?: string;
}

const SeeMoreLink: FC<SeeMoreLinkProps> = ({ text = '', link = '', ...props }) => {
  const context = useContext(EventsReportApiContext);
  if (!context) {
    throw new Error('EventsReportApiContext is not provided');
  }

  const { reportBQ, reportMixpanel, sourcePageKey } = context;
  const fiverrGuidesHomepageUrl = link || '/resources/guides'; // Pathfinder issue: https://github.com/fiverr/pathfinder/issues/45

  const handleClickLink = () => {
    reportBQ('see-more-link');
    reportMixpanel(
      MIXPANEL_EVENT_TITLE.CLICKED_SEE_MORE_GUIDES,
      mixpanelEventEnrichment(sourcePageKey, seeMoreEventPayload(fiverrGuidesHomepageUrl))
    );
  };

  return (
    <Link
      href={fiverrGuidesHomepageUrl}
      target="_blank"
      onClick={() => handleClickLink()}
      rel="noreferrer"
      color={{
        default: 'grey_1200',
        hover: 'grey_1200',
      }}
      textAlign="end"
      marginTop={{
        default: '3',
        md: '0',
      }}
      decoration={{
        default: 'none',
        hover: 'underline',
      }}
      {...props}
    >
      {text || translate('related_guides.see_more_guides')}
    </Link>
  );
};

export default SeeMoreLink;
